<template>
  <app-form
    ref="form"
    @on-submit="onSubmit"
    :readonly="readonly"
    :schema="schema"
    :data="formModel"
    :layout="layout"
    @on-input="onFormFieldChanged"
  >
    <div slot="status">
      <div :class="{'text-green' : formModel.status === 'APPROVED', 'text-red': formModel.status !== 'APPROVED' }"  class="status">
        <i :class="{'fa-check-circle' : formModel.status === 'APPROVED', 'fa-ban':  formModel.status !== 'APPROVED'}"  class="fa"></i>
        <strong>{{formModel.status === 'APPROVED' ? this.$t('invoice.approved') : this.$t('invoice.waitingForApproval')}}</strong>
      </div>
    </div>

  </app-form>
</template>

<script>
import AppForm from '@/components/app-form/';
import { getTagOptions } from '@/utils/tag';

export default {
  name: 'InvoiceForm',
  components: {
    AppForm,
  },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    formModel: Object,
  },
  data() {
    return {
      layout: {
        'div.row': {
          'div.col-md-2:0': {
            field: 'kind_of',
          },
          'div.col-md-1:0': {
            field: 'invoice_number',
          },
          'div.col-md-3:1': {
            field: 'invoice_serial',
          },
          'div.col-md-3:2': {
            field: 'issued_date',
          },
          'div.col-md-3:3': {
            field: 'paid_date',
          },
        },
        'div.row:1': {
          'div.col-md-6:0': {
            field: 'seller_name',
          },
          'div.col-md-6:1': {
            field: 'buyer_name',
          },
        },
        'div.row:2': {
          'div.col-md-6:0': {
            field: 'seller_address',
          },
          'div.col-md-6:1': {
            field: 'buyer_address',
          },
        },
        'div.row:3': {
          'div.col-md-6:0': {
            field: 'seller_taxcode',
          },
          'div.col-md-6:1': {
            field: 'buyer_taxcode',
          },
        },
        'div.row:4': {
          'div.col-md-6:0': {
            field: 'total_amount_with_tax',
          },
          'div.col-md-6:1': {
            field: 'total_amount_without_tax',
          },
        },
        'div.row:5': {
          'div.col-md-6:0': {
            field: 'tax_percentage',
          },
          'div.col-md-6:1': {
            field: 'cqt_code',
          },
        },
        'div.row:6': {
          'div.col-md-12': {
            field: 'content',
          },
        },
        'div.row:8': {
          'div.col-md-12': {
            field: 'tags',
          },
        },
      },
      schema: [
        {
          name: 'einvoice_provider',
          label: this.$t('user.eAccountProvider'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.eAccountProvider')}`,
          type: 'select',
          options: [
            { value: 'E_VNPT', text: 'Vnpt' },
            { value: 'E_VIETTEL', text: 'Viettel' },
            { value: 'E_BKAV', text: 'Bkav' },
          ],
        },
        {
          name: 'invoice_serial',
          label: this.$t('invoice.serial'),
          placeholder: 'Nhập ký hiệu',
          type: 'input',
        },
        {
          name: 'invoice_number',
          label: this.$t('invoice.invoiceNo'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.invoiceNo')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'seller_name',
          label: this.$t('invoice.seller_name'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.seller_name')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'seller_address',
          label: this.$t('invoice.seller_address'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.seller_address')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'seller_taxcode',
          label: this.$t('invoice.seller_taxcode'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.seller_taxcode')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'buyer_name',
          label: this.$t('invoice.buyer'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.buyer_name')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'buyer_address',
          label: this.$t('invoice.buyer_address'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.buyer_address')}`,
          type: 'input',
          asyncValidation(value, resolve, formData) {
            let result = true;
            if (formData.buyer_taxcode && !formData.buyer_address) {
              result = { msg: this.$t('invoice.buyer_address_required') };
            }
            resolve(result);
          },
        },
        {
          name: 'buyer_taxcode',
          label: this.$t('invoice.buyer_taxcode'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.buyer_taxcode')}`,
          type: 'input',
        },
        {
          name: 'issued_date',
          label: this.$t('invoice.date'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.date')}`,
          validation: 'required',
          type: 'datepicker',
        },
        {
          name: 'paid_date',
          label: this.$t('invoice.paidDate'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.paidDate')}`,
          type: 'datepicker',
        },
        {
          name: 'content',
          label: this.$t('invoice.content'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.content')}`,
          type: 'input',
        },
        {
          name: 'tax_percentage',
          label: 'VAT(%)',
          placeholder: `${this.$t('app.enter')} VAT(%)`,
          inputType: 'number',
          type: 'input',
        },
        {
          name: 'total_amount_without_tax',
          label: this.$t('invoice.total_amount_without_tax'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.total_amount_without_tax')}`,
          type: 'currency',
          validation: 'required',
        },
        {
          name: 'total_amount_with_tax',
          label: this.$t('invoice.total_amount_with_tax'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.total_amount_with_tax')}`,
          type: 'currency',
        },
        {
          name: 'kind_of',
          type: 'select',
          label: this.$t('invoice.typeInvoice'),
          options: [
            { value: false, text: 'Hoá đơn đầu vào' },
            { value: true, text: 'Hoá đơn đầu ra' },
          ],
        },
        {
          name: 'cqt_code',
          label: this.$t('invoice.taxAgencyCode'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.taxAgencyCode')}`,
          type: 'input',
        },
        {
          name: 'tags',
          label: this.$t('invoice.tag'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.tag')}`,
          type: 'multi-checkbox',
          options: getTagOptions(),
        },
      ],
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    initialize() {
      this.$refs.form.initialize(this.formModel);
    },
    getValues() {
      return this.$refs.form.getValues();
    },
    submit() {
      return this.$refs.form.submit();
    },
    validate() {
      return this.$refs.form.validate();
    },
    onFormFieldChanged($event, field) {
      const formVm = this.$refs.form;
      if (!field) {
        return;
      }
      const vat = formVm.getFieldValue('tax_percentage') || 0;
      if (field.name === 'total_amount_without_tax') {
        formVm.setFieldValue('total_amount_with_tax', `${Math.round(parseInt(field.value, 0) * ((100 + parseInt(vat, 0)) / 100))}`);
        return;
      }
      if (field.name === 'tax_percentage') {
        const amount = formVm.getFieldValue('total_amount_without_tax') || 0;
        formVm.setFieldValue('total_amount_with_tax', `${Math.round(parseInt(amount, 0) * ((100 + parseInt(field.value, 0)) / 100))}`);
      }
    },
    onSubmit(formModel, validate, { resolve, reject }) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.$emit('on-submit', formModel, validate, { resolve, reject });
        }
      });
    },
  },
  watch: {
    formModel() {
      setTimeout(() => {
        this.$refs.form.initialize(this.formModel);
      }, 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-form.vue